import styled from 'styled-components';
import { CollapseSectionStyled } from 'pages/property/common/Common.styles';
import { breakpoints } from 'styles/mediaQuery';

export const PropertyVrboSettingsCollapseStyled = styled(CollapseSectionStyled)`
  .vrbo-settings-column-2 .form-field-container {
    margin-bottom: 0;
  }

  fieldset > .row:last-child {
    margin-top: 15px;
  }

  @media (min-width: ${breakpoints.SM}px) {
    .add-policy-period-column {
      margin-left: 20.15%;
    }

    .policy-period-field > label {
      width: 20.15%;
    }

    .policy-period-field > label + div {
      width: 79.85%;
    }

    .policy-period {
      input {
        width: 65px;
      }

      .help-block {
        margin-top: 0;
        position: absolute;
        width: 250px;
      }
    }

    fieldset > .row:last-child {
      margin-top: 0;
    }
  }

  .policy-periods-column {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .policy-period {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;

    .form-field-container {
      margin-bottom: 0;

      > div {
        padding-left: 0;
        padding-right: 0;
      }
    }

    button {
      padding: 6px;
    }
  }
`;

export const VrboPromotionPlanWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .form-field-container {
    margin-bottom: 15px !important;
  }
`;
